// extracted by mini-css-extract-plugin
export default {"canvas":"LandingCanvas_canvas__3xK48"};